import numeral from "numeral";

const percentage = value => numeral(value).format("0.[00]%");

const separator = value => numeral(value).format("0,0");

const currency = value => numeral(value).format("$0,0.00");

const currencyShort = value => numeral(value).format("$0,0");

const two_decimals = value => numeral(value).format("0.00");

const one_decimal = value => numeral(value).format("0.0");

export default {
  percentage,
  separator,
  currency,
  currencyShort,
  two_decimals,
  one_decimal
};
